package ru.dinarastepina.fabvocab.web.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

object IndigoPalette : ColorPalette {
    override val _50 = Color.rgb(0xEEF2FF)
    override val _100 = Color.rgb(0xE0E7FF)
    override val _200 = Color.rgb(0xC7D2FE)
    override val _300 = Color.rgb(0xA5B4FC)
    override val _400 = Color.rgb(0x818CF8)
    override val _500 = Color.rgb(0x6366F1)
    override val _600 = Color.rgb(0x4F46E5)
    override val _700 = Color.rgb(0x4338CA)
    override val _800 = Color.rgb(0x3730A3)
    override val _900 = Color.rgb(0x312E81)
}

object SlatePalette : ColorPalette {
    override val _50 = Color.rgb(0xF8FAFC)
    override val _100 = Color.rgb(0xF1F5F9)
    override val _200 = Color.rgb(0xE2E8F0)
    override val _300 = Color.rgb(0xCBD5E1)
    override val _400 = Color.rgb(0x94A3B8)
    override val _500 = Color.rgb(0x64748B)
    override val _600 = Color.rgb(0x475569)
    override val _700 = Color.rgb(0x334155)
    override val _800 = Color.rgb(0x1E293B)
    override val _900 = Color.rgb(0x0F172A)
}

object EmeraldPalette : ColorPalette {
    override val _50 = Color.rgb(0xECFDF5)
    override val _100 = Color.rgb(0xD1FAE5)
    override val _200 = Color.rgb(0xA7F3D0)
    override val _300 = Color.rgb(0x6EE7B7)
    override val _400 = Color.rgb(0x34D399)
    override val _500 = Color.rgb(0x10B981)
    override val _600 = Color.rgb(0x059669)
    override val _700 = Color.rgb(0x047857)
    override val _800 = Color.rgb(0x065F46)
    override val _900 = Color.rgb(0x064E3B)
}

object RosePalette : ColorPalette {
    override val _50 = Color.rgb(0xFFF1F2)
    override val _100 = Color.rgb(0xFFE4E6)
    override val _200 = Color.rgb(0xFECDD3)
    override val _300 = Color.rgb(0xFDA4AF)
    override val _400 = Color.rgb(0xFB7185)
    override val _500 = Color.rgb(0xF43F5E)
    override val _600 = Color.rgb(0xE11D48)
    override val _700 = Color.rgb(0xBE123C)
    override val _800 = Color.rgb(0x9F1239)
    override val _900 = Color.rgb(0x881337)
}

object AmberPalette : ColorPalette {
    override val _50 = Color.rgb(0xFFFBEB)
    override val _100 = Color.rgb(0xFEF3C7)
    override val _200 = Color.rgb(0xFDE68A)
    override val _300 = Color.rgb(0xFCD34D)
    override val _400 = Color.rgb(0xFBBF24)
    override val _500 = Color.rgb(0xF59E0B)
    override val _600 = Color.rgb(0xD97706)
    override val _700 = Color.rgb(0xB45309)
    override val _800 = Color.rgb(0x92400E)
    override val _900 = Color.rgb(0x78350F)
}
